import { useQuery } from '@tanstack/react-query';
import { useEnabledQuery } from '../../../ui/hooks/useEnabledQuery';
import { ResourceType } from '../../enumerations/ResourceType';
import { ParentedArtifactResource } from '../artifactResourceTypes';
import { PersistableSchemaType } from '../persistableResourceTypes';
import { useResourceAdapterActions } from './useResourceAdapterActions';

export function useMultiResourceMultiParentedResourceAdapterBaseActions<R extends ParentedArtifactResource>(
    apiPostfix: string,
    resourceType: ResourceType,
    resourceSchema: PersistableSchemaType<R>
) {
    const actions = useResourceAdapterActions(apiPostfix, resourceType, resourceSchema);
    const getEnabled = useEnabledQuery();

    const useGetAllResources = (parentRelation: string | undefined, parentId: string | undefined | null) => {
        return useQuery({
            queryKey: [parentId, parentRelation, resourceType],
            queryFn: () => actions.getAllResourcesWithParent(parentId as string, parentRelation),
            enabled: getEnabled(parentId && parentRelation),
        });
    };

    return {
        batchAddResourceWithParentRelation: actions.batchAddResourceWithParentRelation,
        addOrSetResource: actions.addOrSetResource,
        addResourceToIndex: actions.addResourceToIndex,
        getSingleFromParent: actions.getSingleFromParent,
        getAllResourcesWithParent: actions.getAllResourcesWithParent,
        changeIndexOfResource: actions.changeIndexOfResource,
        getAllResources: actions.getAllResources,

        useValidateResource: actions.useValidateResource,
        useValidateAllResourcesMultiParented: actions.useValidateAllResourcesMultiParented,
        useGetResource: actions.useGetResource,
        getParentRelationText: actions.getParentRelationText,
        useUpdateResource: actions.useUpdateResource,
        useDeleteResource: actions.useDeleteResource,
        processMutationResponse: actions.processMutationResponse,
        processGetResponse: actions.processGetResponse,
        processGetCollectionResponse: actions.processGetCollectionResponse,
        processGetResourceResponse: actions.processGetResourceResponse,
        useGetAllResources,
    };
}
